export function createFilterPredicate<T extends Record<string, any>>() {
  return (data: T, filter: string): boolean => {
    const filterValue = filter.trim().toLowerCase();

    const dataStr = Object.keys(data)
      .map(key => {
        const value = data[key];

        if (typeof value === 'object' && value !== null) {
          return Object.values(value)
            .map(v => String(v ?? "").toLowerCase()) // Evita errores con valores null o undefined
            .join(" ");
        }

        return String(value ?? "").toLowerCase(); // Convierte valores nulos o indefinidos a string vacío
      })
      .join(" ");

    return dataStr.includes(filterValue);
  };
}
